export const RouteNames = {
    SPORT: "sport",
    LIVE: "live",
    PREMATCH: "prematch",
    RESULTS: "results",
    TOP: "top",
    UPCOMING: "upcoming",
    CALENDAR: "calendar",
    MULTI_VIEW: "multi-view",
    CASINO: "casino",
    TAG: "tag",
    LIVE_CASINO: "livecasino",
    SLOTS: "slots",
    ALL: "all",
    REFERRAL: "referral",
    POLICIES: "policies",
    SPORTSBOOK: "sportsbook",
    TERMS: "terms",
    PRIVACY: "privacy",
    PAYMENTS: "payments",
    RESPONSIBLE_GAMING: "responsible-gaming",
    COOKIES: "cookies",
    SELF_EXCLUSION: "self-exclusion",
    KYC: "kyc",
    FAIRNESS_RNG_TESTING: "fairness-rng-testing",
    DISPUTE_RESOLUTION: "dispute-resolution",
    ANTI_MONEY_LAUNDERING: "anti-money-laundering",
    BONUSES: "bonuses",
    ABOUT: "about",
    CONTACT: "contact",
    CASHBACK: "cashback",
    BONUS_REFERRAL: "bonus-referral",
    PROMOTIONS: "promotions",
    FAVORITES: "favorites",
    REEL: "reel",
    ACCOUNT: "account",
    DETAILS: "details",
    BETS: "bets",
    PERSONAL: "personal",
    "2FA": "2fa",
    MESSAGES: "messages",
    INBOX: "inbox",
    SENT: "sent",
    COMPOSE: "compose",
    SEARCH: "search",
    TRANSACTIONS: "transactions",
    VERIFICATION: "verification",
};
